import React, { useEffect, useState } from 'react'
import { Button, Input, Spin, Table, notification } from 'antd'
import {
  ActivateFromPracticeSquad,
  AuctionPlayer,
  MoveToInjured,
  MoveToPracticeSquad,
  MoveToReserve,
  PoachPlayer,
  ReleasePlayer,
  TradePlayer,
} from '../modal/PlayerInterfaceModals'
import Loader from '../Loader'

import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  addBid,
  auctionEnded,
  createAuction,
  getFreeAgentRosterPlayer,
  getRosterPlayer,
  getSingleAuctionPlayer,
} from '../../redux/actions/rosterAction'

import { getAge, checkWaiver, getPf, getRankAndPosition } from '../../config/helperFunctions'

import { AiOutlineCloseCircle } from 'react-icons/ai'

import Image from '../../assets/hockey-logo-1.png'
import moment from 'moment'
import { isLocked } from '../../config/constants'

const PlayerInterfacePopup = ({ closeModal }) => {
  const SETTING = useSelector((state) => state?.user?.setting)
  const INTERFACE = useSelector((state) => state.interfaceModal)
  const [isLoading, setIsLoading] = useState(true)
  const [auctionLoading, setAuctionLoading] = useState(false)
  const [data, setData] = useState({
    player: {},
    news: null,
    activePlayers: [],
    practicePlayers: [],
    reservedPlayers: [],
  })

  const playerIdBig = data?.player?.player_id?._id
  const playerIdSmall = data?.player?.player_id?.PlayerID
  const isPlayerLocked = data?.player?.isPlayerLocked
  const inPracticeSquad = data?.player?.inPracticeSquad

  const isTransaction = INTERFACE?.state?.isTransaction
  const isOwnRoster = INTERFACE?.state?.isOwnRoster
  const isFreeAgent = INTERFACE?.state?.isFreeAgent
  const isAuction = INTERFACE?.state?.auction?.isAuction
  const hasAuctionEnded = INTERFACE?.state?.auction?.hasAuctionEnded

  const navigate = useNavigate()

  const getDailyScoring = (arr) => {
    if (arr?.length > 0) {
      let unique_values = [...new Set(arr.map((v) => v?.season))]
      const newArray = []

      unique_values
        ?.sort((a, b) => b - a)
        ?.forEach((v) => {
          const filteredSeasonScore = arr?.filter((x) => Number(x?.season) === v)

          const finalDailyScore = {}
          const dates = {}

          if (arr?.length > 7) {
            let slicedArr = filteredSeasonScore?.slice(arr?.length - 7, arr?.length)

            for (let i = 1; i <= 7; i++) {
              if (i < slicedArr?.length) {
                finalDailyScore[`day${i}`] = slicedArr?.[i - 1]?.score?.toFixed(3)
                dates[`date${i}`] = slicedArr?.[i - 1]?.date
              } else {
                finalDailyScore[`day${i}`] = 0
              }
            }
          } else {
            for (let i = 1; i <= 7; i++) {
              if (i < filteredSeasonScore?.length) {
                finalDailyScore[`day${i}`] = filteredSeasonScore?.[i - 1]?.score?.toFixed(3)
                dates[`date${i}`] = filteredSeasonScore?.[i - 1]?.date
              } else {
                finalDailyScore[`day${i}`] = 0
              }
            }
          }

          // const finalScoring = {}
          // for (let i = 1; i <= 10; i++) {
          //   if (filteredSeasonScore.find((x) => x?.week === i)) {
          //     finalScoring[`week${i}`] = filteredSeasonScore.find((x) => x?.week === i)?.score
          //   } else {
          //     finalScoring[`week${i}`] = 0
          //   }
          // }

          // const finalDailyScore = {}
          // const dates = {}

          // for (let i = 1; i <= 10; i++) {
          //   if (i < filteredSeasonScore?.length) {
          //     finalDailyScore[`day${i}`] = filteredSeasonScore?.[i - 1]?.score?.toFixed(3)
          //     dates[`date${i}`] = filteredSeasonScore?.[i - 1]?.date
          //   } else {
          //     finalDailyScore[`day${i}`] = 0
          //   }
          // }

          const totalPf = filteredSeasonScore?.reduce((acc, obj) => acc + obj.score, 0)

          const scoreGreaterZero = filteredSeasonScore?.filter((item) => item?.score > 0)

          newArray?.push({
            season: v,
            totalPoints: totalPf?.toFixed(2),
            // avgPoints: totalPf > 0 ? (totalPf / filteredSeasonScore?.length)?.toFixed(2) : 0,
            avgPoints: totalPf > 0 ? (totalPf / scoreGreaterZero?.length)?.toFixed(2) : 0,
            dailyScoring: finalDailyScore,
            dates,
            // weeklyScoring: finalScoring,
          })
        })
      return newArray
    }
  }

  useEffect(() => {
    if (INTERFACE?.isOpen) {
      getData()
    }
  }, [INTERFACE?.isOpen])

  const getData = async () => {
    setIsLoading(true)
    if (isTransaction?.status) {
      await getFreeAgentPlayer()
    } else if (isFreeAgent) {
      await getFreeAgentPlayer()
    } else if (isAuction) {
      await getAuctionPlayer()
    } else {
      await getRoster()
    }
    setIsLoading(false)
  }

  // ------------------------------------------------
  const getAuctionPlayer = async () => {
    const res = await getSingleAuctionPlayer(INTERFACE?.state?.auction?.auctionId)
    if (res) {
      // setData({
      //   ...res,
      //   player: {
      //     player_id: res?.player_id,
      //   },
      //   activePlayers: [],
      //   practicePlayers: [],
      //   reservedPlayers: [],
      // })
      setData({
        ...res,
        player: {
          player_id: res?.player_id,
        },
        activePlayers: [],
        practicePlayers: [],
        reservedPlayers: [],
        playerHistory: getDailyScoring(res?.player_id?.dailyScoring),
      })
    }
  }
  const getFreeAgentPlayer = async () => {
    const res = await getFreeAgentRosterPlayer({
      id: Number(INTERFACE?.state?.playerID),
      date: SETTING?.date,
    })
    if (res) {
      // setData({
      //   player: {
      //     player_id: res?.player,
      //   },
      //   news: res?.news,
      //   activePlayers: [],
      //   practicePlayers: [],
      //   reservedPlayers: [],
      // })
      setData({
        player: {
          player_id: res?.player,
        },
        news: res?.news,
        activePlayers: [],
        practicePlayers: [],
        reservedPlayers: [],
        playerHistory: getDailyScoring(res?.player?.dailyScoring),
      })
    }
  }
  const getRoster = async () => {
    const res = await getRosterPlayer({
      id: INTERFACE?.state?.playerID,
      date: SETTING?.date,
      team: INTERFACE?.state?.teamId,
    })
    if (res) {
      // setData(res)
      setData({ ...res, playerHistory: getDailyScoring(res?.player?.player_id?.dailyScoring) })
    }
  }
  // -------------------------------------------------

  const getBgImage = (position) => {
    const p = position?.toLowerCase()
    return p === 'lw' ? 'w' : p === 'rw' ? 'w' : p
  }

  const generateWeekColumn = (weekNumber) => ({
    title: (
      <p>
        WK<b>{weekNumber}</b>
      </p>
    ),
    dataIndex: `week${weekNumber}`,
    key: `week${weekNumber}`,
    render: (t) => (t ? t : '-'),
  })

  const columns = [
    {
      title: 'YEAR',
      dataIndex: 'season',
      key: 'season',
      render: (t) => (t ? t : '-'),
    },
    {
      title: 'TOTAL POINTS',
      dataIndex: 'totalPoints',
      key: 'totalPoints',
      render: (t) => (t ? t : '-'),
      width: 130,
    },
    {
      title: 'AVG. POINTS',
      dataIndex: 'avgPoints',
      key: 'avgPoints',
      render: (t) => (t ? t : '-'),
      width: 130,
    },
    // ...Array.from({ length: 18 }, (_, index) => generateWeekColumn(index + 1)),
    ...Array.from({ length: 7 }, (_, index) => ({
      title: (
        <p>
          DAY<b>{index + 1}</b>
        </p>
      ),
      dataIndex: `day${index + 1}`,
      key: `day${index + 1}`,
      render: (_, obj) =>
        obj?.dailyScoring?.[`day${index + 1}`] ? obj?.dailyScoring?.[`day${index + 1}`] : '-',
      // <>
      //   {obj?.dailyScoring?.[`day${index + 1}`] ? (
      //     <div>
      //       <span>{obj?.dailyScoring?.[`day${index + 1}`]}</span>
      //       <span style={{marginLeft: '5px'}}>({moment(obj?.dates?.[`date${index + 1}`]).format('D/M/YY')})</span>
      //     </div>
      //   ) : (
      //     '-'
      //   )}
      // </>
    })),
  ]
  const getYear = (contract) => {
    const signed = contract?.split(' signed a ')[1][0]
    if (signed) {
      return new Date().getFullYear() - 1 + Number(signed)
    } else {
      return '-'
    }
  }

  const handleCreateAuction = async () => {
    setAuctionLoading(true)
    const res = await createAuction({
      PlayerID: playerIdSmall,
      player_id: playerIdBig,
      auctionFrom: 'nonowner',
    })
    if (res) {
      closeModal()
      navigate('/player-auction')
    }
    setAuctionLoading(false)
  }

  const isWaiver = checkWaiver(
    data?.player?.player_id?.BirthDate, // age
    (data?.player?.player_id?.gamesPlayed || 0) +
      (data?.player?.player_id?.nhlGamesPlayed || 0) -
      16, // game player
    data?.player?.player_id?.Position, // position
  )

  return (
    <div className='player_interface_popup'>
      <AiOutlineCloseCircle className='close_icon' onClick={closeModal} />
      {isLoading ? (
        <Loader />
      ) : (
        <div className='wrapper'>
          {INTERFACE?.state?.teamId && (
            <div className='viewing_roster_heading'>
              <h2>Your are viewing {INTERFACE?.state?.teamName || 'other team'} rosters.</h2>
            </div>
          )}
          <div className='top_row'>
            <div className='top_row_1'>
              <div className='image_box'>
                <img
                  className='bg_image'
                  src={
                    data?.player?.player_id?.Position
                      ? require(`../../assets/interface/${getBgImage(
                          data?.player?.player_id?.Position,
                        )}.png`)
                      : ''
                  }
                />
                <div className='player_img_box'>
                  {data?.player?.player_id?.HostedHeadshotNoBackgroundUrl ? (
                    <img src={data?.player?.player_id?.HostedHeadshotNoBackgroundUrl} />
                  ) : (
                    <img
                      src={
                        data?.player?.player_id?.Position === 'G'
                          ? require('../../assets/goalie-player.jpeg')
                          : require('../../assets/hockey-player.jpeg')
                      }
                    />
                  )}
                </div>
                <h2 className='player_name'>{data?.player?.player_id?.Name || '-'}</h2>
                <h2 className='player_opponent'>{data?.player?.player_id?.Opponent || '-'}</h2>
                <h2 className='player_team'>{data?.player?.player_id?.Team || '-'}</h2>
                <h2 className='player_projection'>
                  {data?.player?.player_id?.InjuryStatus || '-'}
                </h2>
              </div>
            </div>
            <div className='top_row_2'>
              <p className='top_player_name'>
                {data?.player?.player_id?.FirstName}
                <b>{data?.player?.player_id?.LastName}</b>
              </p>
              <div className='player_details_box'>
                <p>
                  <b>position:</b>
                  {data?.player?.player_id?.Position}
                </p>
                <p>
                  <b>team:</b>
                  {data?.player?.player_id?.Team}
                </p>
              </div>
              <div className='player_details_box'>
                <p>
                  <b>age:</b>
                  {getAge(data?.player?.player_id?.BirthDate)}
                </p>
                <p>
                  <b>height:</b>
                  {data?.player?.player_id?.Height ? data?.player?.player_id?.Height : '-'}
                </p>
                <p>
                  <b>weight:</b>
                  {data?.player?.player_id?.Weight ? (
                    <>
                      {data?.player?.player_id?.Weight}
                      <span>lbs</span>
                    </>
                  ) : (
                    '-'
                  )}
                </p>
                <p>
                  <b>exp:</b>
                  {data?.player?.player_id?.Experience ? (
                    data?.player?.player_id?.Experience <= 1 ? (
                      <>
                        {data?.player?.player_id?.Experience}
                        <span>Year</span>
                      </>
                    ) : (
                      <>
                        {data?.player?.player_id?.Experience}
                        <span>Years</span>
                      </>
                    )
                  ) : (
                    '-'
                  )}
                </p>
              </div>
              <div className='player_news_box'>
                <p className='title'>
                  player<b>news</b>
                </p>
                <p className='news_text'>{data?.news || 'No news available'}</p>
              </div>
            </div>
            {INTERFACE?.state?.teamLogo && (
              <div className='top_row_3'>
                <p>
                  OWNING<b>TEAM</b>
                </p>
                {INTERFACE?.state?.teamLogo && (
                  <img src={INTERFACE?.state?.teamLogo} alt='Team Logo' />
                )}
              </div>
            )}
            {!isTransaction?.status && (
              <div className='top_row_4'>
                {isFreeAgent && (
                  <Button loading={auctionLoading} onClick={handleCreateAuction} type='primary'>
                    AUCTION PLAYER
                  </Button>
                )}
                {INTERFACE?.state?.teamId && !isLocked() && (
                  <>
                    <Button
                      type='primary'
                      onClick={() => {
                        closeModal()
                        navigate('/team-trade')
                      }}
                    >
                      Make Offer
                    </Button>
                    {/* <PoachPlayer /> */}
                  </>
                )}
                {INTERFACE?.state?.teamId && isLocked() && <PreviousDayView />}
                {isAuction && !hasAuctionEnded && <LiveAuctionBid data={data} getData={getData} />}
                {isAuction && hasAuctionEnded && <WinningBid data={data} />}
                {isOwnRoster?.status && !isLocked() && (
                  <>
                    <AuctionPlayer
                      disabled={isPlayerLocked}
                      playerIds={{
                        PlayerID: playerIdSmall,
                        player_id: playerIdBig,
                      }}
                      pInterfaceModalClose={closeModal}
                    />

                    <TradePlayer disabled={isPlayerLocked} pInterfaceModalClose={closeModal} />

                    <ReleasePlayer
                      disabled={isPlayerLocked}
                      playerId={playerIdBig}
                      pInterfaceModalClose={closeModal}
                    />

                    {INTERFACE?.state?.isReserve && (
                      <MoveToReserve
                        disabled={data?.player?.isReserved || isPlayerLocked}
                        playerId={playerIdBig}
                        reservedPlayers={data?.reservedPlayers?.length}
                        pInterfaceModalClose={closeModal}
                      />
                    )}

                    <MoveToInjured
                      disabled={
                        data?.player?.player_id?.InjuryStatus?.toLowerCase() != 'out' ||
                        isPlayerLocked
                      }
                      playerId={playerIdBig}
                      pInterfaceModalClose={closeModal}
                    />

                    <ActivateFromPracticeSquad
                      disabled={!inPracticeSquad || isPlayerLocked}
                      playerId={playerIdBig}
                      activePlayers={data?.activePlayers}
                      pInterfaceModalClose={closeModal}
                    />

                    <MoveToPracticeSquad
                      disabled={inPracticeSquad || isPlayerLocked}
                      playerId={playerIdBig}
                      activePlayersCount={data?.activePlayers?.length}
                      practicePlayers={data?.practicePlayers}
                      pInterfaceModalClose={closeModal}
                    />
                  </>
                )}
                {isOwnRoster?.status && isLocked() && <PreviousDayView />}
              </div>
            )}
          </div>

          <div className='bottom_row'>
            <div className='left'>
              <div className='left_top'>
                <div>
                  <h2>Player Rank</h2>
                  <div className='player_rank_box'>
                    <div>
                      <p className='text_1'>
                        {
                          getRankAndPosition(data?.player?.player_id?.dailyScoring)
                            ?.playerPositionRank
                        }
                      </p>
                      <p className='text_2'>POSITION</p>
                    </div>
                    <div style={{ alignSelf: 'flex-start' }}>
                      <p className='text_2' style={{ fontSize: '18px' }}>
                        |
                      </p>
                    </div>
                    <div>
                      <p className='text_1'>
                        {
                          getRankAndPosition(data?.player?.player_id?.dailyScoring)
                            ?.playerOverallRank
                        }
                      </p>
                      <p className='text_2'>OVERALL</p>
                    </div>
                  </div>
                </div>
                <div>
                  <h2>Ownership</h2>
                  <div className='ownership_box'>
                    <div>
                      <p className='text_1'>0%</p>
                      <p className='text_2'>ROSTERED</p>
                    </div>
                  </div>
                </div>
                <div>
                  <h2>TPF / APF</h2>
                  <div className='tpf_apf_box'>
                    <p>{getPf(data?.player?.player_id?.dailyScoring)?.tpf}</p>
                    <span style={{ fontSize: '22px', color: '#fff' }}>|</span>
                    <p>{getPf(data?.player?.player_id?.dailyScoring)?.apf}</p>
                  </div>
                </div>
                <div>
                  {isWaiver ? (
                    <div className='waiver_box_1'>
                      <p className='p1'>
                        WAIVER <b>STATUS</b>
                      </p>
                      <p className='p2'>
                        <b>{isWaiver}</b> GAMES
                      </p>
                      <p className='p3'>Until Waiver Eligible</p>
                    </div>
                  ) : (
                    <div className='waiver_box_2'>
                      <p className='p1'>
                        WAIVER <b>STATUS</b>
                      </p>
                      <p className='p2'>
                        <b>WAIVER ELIGIBLE</b>
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className='left_bottom'>
                <p>
                  PLAYER<b>HISTORY</b>
                </p>
                <Table
                  loading={false}
                  // dataSource={[]}
                  dataSource={data?.playerHistory}
                  columns={columns}
                  bordered={false}
                  pagination={false}
                  scroll={{ x: 1000, y: 200 }}
                  className='interface_table'
                />
              </div>
            </div>
            <div className='right'>
              <p>
                PLAYER<b>CONTRACT</b>
              </p>
              <div className='contract_box'>
                <div className='caphit_box'>
                  <p>
                    CAP<b>HIT</b>
                  </p>
                  <p>
                    <b>23&apos;</b>{' '}
                    {data?.player?.player_id?.PlayerCap
                      ? `$${data?.player?.player_id?.PlayerCap?.toLocaleString()}`
                      : '-'}
                  </p>
                </div>
                <div className='caphit_year_box'>
                  <p>
                    24&apos; CAP<b>HIT</b>
                  </p>
                  <div>
                    <p>$-</p>
                  </div>
                </div>
                <div className='caphit_year_box'>
                  <p>
                    FINAL<b>YEAR</b>
                  </p>
                  <div>
                    <p>{getYear(data?.player?.player_id?.contractInfo)}</p>
                  </div>
                </div>
                <div className='contract_info_box'>
                  <p>
                    CONTRACT<b>INFO:</b>
                  </p>
                  <p>{data?.player?.player_id?.contractInfo || 'No contract available'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const PreviousDayView = () => {
  return (
    <div style={{ height: '200px' }}>
      <p style={{ textAlign: 'center' }}>You are viewing previous day data in view only mode.</p>
    </div>
  )
}
const WinningBid = ({ data }) => {
  return (
    <section className='winning_bid_section'>
      <div className='wb_top_row'>
        <img src={Image} />
        <p>Winning Bid</p>
        <p>
          <b>{`$${data?.highestCurrentBid?.toLocaleString()}`}</b>
        </p>
      </div>
      <BidHistoryBox data={data?.bidHistory} height={'130px'} />
    </section>
  )
}
const LiveAuctionBid = ({ data, getData }) => {
  const [noti, contextHolder] = notification.useNotification()
  const [remainingTime, setRemainingTime] = useState('')
  const [isLoading, setIsLoading] = useState({
    type: 'data',
    status: true,
  })
  const [manualBid, setManualBid] = useState('')
  const [bidError, setBidError] = useState('')

  useEffect(() => {
    bidError && setBidError(false)
  }, [manualBid])

  const ended = async () => {
    const res = await auctionEnded({ auctionId: data?._id })
    if (res) {
      await getData()
    }
  }

  useEffect(() => {
    let interval
    if (!data?.hasAuctionEnded) {
      interval = setInterval(() => {
        const now = moment()
        const end = moment(data?.endDate)
        const duration = moment.duration(end.diff(now))
        if (duration.asSeconds() <= 0) {
          clearInterval(interval)
          setRemainingTime('Time is up!')
          ended()
        } else {
          const days = Math.floor(duration.asDays())
          const hours = String(duration.hours()).padStart(2, '0')
          const minutes = String(duration.minutes()).padStart(2, '0')
          const seconds = String(duration.seconds()).padStart(2, '0')
          setRemainingTime(
            days === 0
              ? `${hours} : ${minutes} : ${seconds}`
              : `${days} : ${hours} : ${minutes} : ${seconds}`,
          )
        }
      }, 1000)
    } else {
      setRemainingTime('Time is up!')
    }

    return () => {
      clearInterval(interval)
    }
  }, [data?.endDate])

  const handleManualBid = async () => {
    if (manualBid?.trim() == '') {
      setBidError('ENTER BID BEFORE SUBMIT')
      return
    }
    if (data?.highestCurrentBid >= manualBid) {
      setBidError('PLACE BID HIGHER THEN CURRENT BID')
      return
    }

    setIsLoading({
      type: 'submit',
      status: true,
    })
    const res = await addBid(
      {
        auctionId: data?._id,
        bidAmount: Number(manualBid),
      },
      noti,
    )
    if (res) {
      getData()
    }
    setIsLoading({
      type: 'submit',
      status: false,
    })
  }

  const handleQuickBid = async () => {
    setIsLoading({
      type: 'quick',
      status: true,
    })
    const res = await addBid(
      {
        auctionId: data?._id,
        bidAmount: Number(data?.highestCurrentBid) + 5,
      },
      noti,
    )
    if (res) {
      getData()
    }
    setIsLoading({
      type: 'quick',
      status: false,
    })
  }
  return (
    <>
      {contextHolder}
      <div className='live_auction_bid'>
        <div className='auction_clock'>
          <p>
            AUCTION<b>CLOCK</b>
          </p>
          <p>{remainingTime || '00 : 00 : 00'}</p>
        </div>
        <div className='top_bid'>
          <div className='top_bid_amount'>
            <div className='logo'>
              <img
                src={data?.bidHistory?.find((x) => x?.bid === data?.highestCurrentBid)?.team?.logo}
              />
            </div>
            <div className='amount'>
              <p>
                TOP<b>BID</b>
              </p>
              <p>{data?.highestCurrentBid && `$${data?.highestCurrentBid?.toLocaleString()}`}</p>
            </div>
          </div>
          <div className='bid_button' onClick={handleQuickBid}>
            {isLoading?.status && isLoading?.type === 'quick' ? (
              <Spin />
            ) : (
              <>
                <p>QUICK BID</p>
                <p>$ 5</p>
              </>
            )}
          </div>
        </div>
        <div className='manual_entry'>
          <div className='input_box'>
            <p className='manual_bid_text'>
              MANUAL<b>BID</b>
            </p>
            <Input
              value={manualBid}
              type='number'
              placeholder='Enter here'
              style={{ textAlign: 'center' }}
              onChange={(e) => setManualBid(e.target.value)}
            />
            {bidError != '' && <p className='error_text'>{bidError}</p>}
          </div>
          <div className='bid_button' onClick={handleManualBid}>
            {isLoading?.status && isLoading?.type === 'submit' ? <Spin /> : <p>SUBMIT</p>}
          </div>
        </div>
        <BidHistoryBox data={data?.bidHistory} height={'90px'} />
      </div>
    </>
  )
}
const BidHistoryBox = ({ data, height }) => {
  return (
    <div className='bid_history_box'>
      <p>
        BID<b>HISTORY</b>
      </p>
      <div className='bid_card_box' style={{ height }}>
        <div className='bid_card_header'>
          <div style={{ width: '25px' }}></div>
          <p>USERNAME</p>
          <h3>
            BID
            <br />
            AMOUNT
          </h3>
        </div>
        {data
          ?.slice()
          ?.sort((a, b) => b.bid - a.bid)
          ?.map((v, i) => {
            return (
              <div key={i} className='bid_card'>
                <img src={v?.team?.logo} />
                <p>{v?.user?.userName}</p>
                <h3>{v?.bid && `$${v?.bid?.toLocaleString()}`}</h3>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default PlayerInterfacePopup
